export enum QueryTypes {
  DASHBOARD_DATA = 'dashboard-data',
  APPLICANT_OPT_OUT = 'applicant-opt-out',
  PRIME_LENDERS = 'prime-lenders',
  SUB_PRIME_LENDERS = 'sub-prime-lenders',
  AASO = 'aaso',
  STORE = 'store',
}
